module.exports = __webpack_public_path__ + "static/media/arrow.2881f1f4.svg";